<div class="tab-pane">
  <div class="row">
    <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <app-progress-bar [isLoading]="isLoadingLicensed"></app-progress-bar>
        <div class="card-header text-primary"> Create Single User</div>
        <div class="card-body">
          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" style="min-height: 225px;">
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">First Name</label>
              </div>
              <div class="col-md-8">
                <input type="text" formControlName="firstName" class="form-control form-control-sm inputtext"
                  placeholder="First Name" [ngClass]="{ 'is-invalid': submitted && formField.firstName.errors }" />
                <div *ngIf="submitted && formField.firstName.errors" class="invalid-feedback">
                  <div *ngIf="formField.firstName.errors.required">First Name is required</div>
                </div>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">Last Name</label>
              </div>
              <div class="col-md-8">
                <input type="text" formControlName="lastName" class="form-control form-control-sm inputtext"
                  placeholder="Last Name" [ngClass]="{ 'is-invalid': submitted && formField.lastName.errors }" />
                <div *ngIf="submitted && formField.lastName.errors" class="invalid-feedback">
                  <div *ngIf="formField.lastName.errors.required">Last Name is required</div>
                </div>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">Email Id</label>
              </div>
              <div class="col-md-8">
                <input type="email" formControlName="emailId" class="form-control form-control-sm inputtext"
                  placeholder="Email" [ngClass]="{ 'is-invalid': submitted && formField.emailId.errors }" />
                <div *ngIf="submitted && formField.emailId.errors" class="invalid-feedback">
                  <div *ngIf="formField.emailId.errors.required">EmailId is required</div>
                  <div *ngIf="formField.emailId.errors.email">Email must be a valid email address</div>
                </div>
                <div *ngIf="isEmailError" class="error-msg">Email Already Exists!</div>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">Role</label>
              </div>
              <div class="col-md-8">
                <div class="customSelect">
                  <div class="select" *ngIf="selectedRole">
                    <select formControlName="role" class="form-control form-control-sm" [value]="selectedRole"
                      [(ngModel)]='selectedRole'>
                      <option *ngFor="let item of userRoleList" value="{{item.id}}">
                        {{item.displayTitle}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">Mobile</label>
              </div>
              <div class="col-md-8">
                <input type="text" formControlName="mobile" class="form-control form-control-sm inputtext"
                  placeholder="Mobile no" />
              </div>
            </div>
            <!-- <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">User Id</label>
              </div>
              <div class="col-md-8">
                <input type="text" formControlName="userId" class="form-control form-control-sm inputtext"
                  placeholder="User id"/>
              </div>
            </div> -->
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">User Id</label>
              </div>
              <div class="col-md-8">
                <input type="text" formControlName="UserIdByUser" class="form-control form-control-sm inputtext"
                  placeholder="User Id" [ngClass]="{ 'is-invalid': submitted && formField.UserIdByUser.errors }"
                  (keypress)="keyPressAlphaNumeric($event)" />
                <div *ngIf="submitted && formField.UserIdByUser.errors" class="invalid-feedback">
                  <div *ngIf="formField.UserIdByUser.errors.required">User Id is required</div>
                  <!-- <div *ngIf="formField.UserIdByUser.errors.pattern">User Id must be alpha numeric</div> -->
                </div>
                <div *ngIf="isUserId" class="error-msg">UserId Already Exists!</div>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4">
                <label class="control-label">Division</label>
              </div>
              <div class="col-md-8">
                <mat-form-field class="Jurisdiction_input">
                  <!-- <mat-label>Select Jurisdictions</mat-label> -->
                  <mat-select formControlName="SelectedJurisdictionList" [multiple]="true">
                    <mat-select-trigger>
                      <mat-chip-list>
                        <mat-chip *ngFor="let id of registerForm.get('SelectedJurisdictionList').value" [removable]="true" (removed)="removeJurisdiction(id)">
                          {{ getJurisdictionTitle(id) }}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                      </mat-chip-list>
                    </mat-select-trigger>
                    <mat-option *ngFor="let option of jurisdictionList" [value]="option.id">{{ option.title }}</mat-option>
                  </mat-select>
                </mat-form-field>
               
                <div *ngIf="submitted && formField.SelectedJurisdictionList.errors && formField.SelectedJurisdictionList.touched" class="invalid-feedback">
                  <div *ngIf="formField.SelectedJurisdictionList.errors.required">Jurisdiction is required</div>
                </div>
              </div>
            </div>
            <div class="form-group row mt-3">
              <div class="col-lg-4 col-md-4"></div>
              <div class="col-md-8">
                <p *ngIf="showMsg" style="color:#9278bf; margin-bottom: 0.5rem !important">User Created Successfully!
                </p>
                <p *ngIf="isShowMessage" class="fg-g-red">Oops – No more licences available!</p>
                <button class="btn bg-g-lightGreen btn-sm pull-right" [disabled]="isDisabled">Create
                  <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin"
                    style="font-size: .875rem; line-height: 1.5;"></i>
                </button>
              </div>
            </div>
            <div class="row mt-3" *ngIf="licensedData.allLicensed > 0">
              <div class="col-lg-6 fg-color">Total Licenses: {{licensedData.allLicensed}}</div>
              <div class="col-lg-6 fg-color">Available Licenses: {{licensedData.unUsedLicensed}}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="card">
        <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
        <div class="card-header text-primary">Upload Multiple Users</div>
        <div class="card-body cursor-pointer text-primary">
          <span (click)="downloadUserTemplate()"><span class="fa fa-download"></span> Download Template</span>
          <span (click)="openDialog()" class="ml-20"><span class="fa fa-upload"></span> Upload Bulk Users</span>
        </div>
      </div>
    </div>
  </div>
</div>